import axios from 'axios'
import { useAuthStore } from '../context/authStore'

const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token
    const csrfToken = useAuthStore.getState().csrfToken
    if (token && token !== 'cloud-cookie') {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (csrfToken && config.method && !['get', 'head', 'options'].includes(config.method.toLowerCase())) {
      config.headers['X-CSRF-Token'] = csrfToken
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    const requestUrl = String(error.config?.url || '')
    const loginRequest = requestUrl.endsWith('/auth/login')
    if (error.response?.status === 401 && !loginRequest) {
      useAuthStore.getState().logout()
      if (!window.location.pathname.startsWith('/platform')) window.location.href = '/login'
    }
    return Promise.reject(error.response?.data || error.message)
  }
)

export default api
